export default "/app/9c4845b4b41ef40a22faee76144fa816.svg";